<template>
  <div>
    <el-drawer
      :visible.sync="disableShow"
      v-if="disableShow"
      size="100%"
      direction="rtl"
      :wrapperClosable="false"
      :title="form.id >0 ? '编辑' : '新建'">
      <el-form class="tradeConfigForm" ref="form" :model="form" label-width="90px" :rules="rules" :show-message="true">
        <el-form-item label="交易平台">
          <el-select v-model="form.platform" default-first-option placeholder="请选择" :disabled="form.id > 0"
                     @change="changePlatform">
            <el-option key="okx" label="okx" value="okx"></el-option>
            <el-option key="binance" label="binance" value="binance"></el-option>
            <el-option key="mexc" label="mexc" value="mexc"></el-option>
            <el-option key="gate" label="gate.io" value="gate"></el-option>
            <el-option key="bitget" label="bitget" value="bitget"></el-option>
            <el-option key="xt" label="XT.com" value="xt"></el-option>
            <el-option key="bybit" label="bybit" value="bybit"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="instId" v-show="form.platform && JSON.stringify(instrumentsOpts) !== '{}'">
          <el-select ref="instIdSelect"
                     @hook:mounted="cancelReadOnly"
                     @visible-change="cancelReadOnly"
                     :popper-append-to-body="false"
                     v-model="form.instId" clearable filterable placeholder="请选择instId">
            <el-option v-for="(item, idx) in instrumentsOpts" :key="idx" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="is_enable">
          <el-switch :value="form.is_enable === 1" @change="changeSwitch()"></el-switch>
        </el-form-item>
        <el-form-item label="杠杆倍数" prop="lever">
          <el-input-number v-model="form.lever" size="medium" :min="1" :max="100" :precision="0" :step="1">
          </el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit()">提交</el-button>
          <el-button @click="disableShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import api from '@/api/api'

const defaultForm = {
  id: 0,
  is_enable: 1,
  platform: '',
  instId: 'ETH-USDT-SWAP',
  lever: 5
}

export default {
  name: 'TradeConfigSave',
  data () {
    return {
      disableShow: false,
      form: { ...defaultForm },
      instrumentsOpts: [],
      rules: {
        instId: [
          { required: true, message: 'instId必填', trigger: 'blur' }
        ],
        is_enable: [
          { required: true, message: '是否启用必填', trigger: 'change' }
        ],
        lever: [
          { required: true, message: '杠杆倍数必填', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    async getPlatformTradePairs () {
      this.$loading({ body: true })
      await api.platformTradePairs({ platform: this.form.platform, trade_type: 'future' }).then(res => {
        this.instrumentsOpts = res.data
      }).catch(e => {
        this.$message.error('获取可选货币列表失败')
      }).finally(_ => {
        this.$loading({}).close()
      })
    },
    async changePlatform () {
      this.form.instId = ''
      this.instrumentsOpts = []
      await this.getPlatformTradePairs()
    },
    // 取消只读
    cancelReadOnly (onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { instIdSelect } = this.$refs
          const input = instIdSelect.$el.querySelector('.el-input__inner')
          input.removeAttribute('readonly')
        }
      })
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$loading({ body: true })
          const params = { ...this.form }
          api.tradeConfigSave(params).then(res => {
            if (res.code === 0) {
              this.$message.success({
                message: '操作成功',
                customClass: 'phone-custom-message'
              })
              this.disableShow = false
            } else {
              this.$message.error(res.message)
            }
          }).catch(res => {
            this.$message.error(res)
          }).finally(() => {
            this.$loading({}).close()
            this.$emit('successfn')
          })
        } else {
          return false
        }
      })
    },
    changeSwitch () {
      this.form.is_enable = this.form.is_enable !== 1
      return this.form.is_enable
    },
    async show (item) {
      this.$loading({ body: true })
      this.disableShow = true
      if (item) {
        this.form = { ...item }
      } else {
        this.form = { ...defaultForm }
      }

      // 获取可选货币列表
      if (this.form.platform) {
        await this.getPlatformTradePairs()
      }
      this.$loading({}).close()
    }
  }
}
</script>

<style scoped>
.tradeConfigForm {
  padding-right: 15px;;
}
.tradeConfigForm .el-form-item {
  margin-bottom: 10px;
}
.trigger-level-form {
  padding-top: 5px;
}
</style>
<style>
.U-append .el-input-group__append {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.phone-custom-message {
  top: 30% !important; /* 垂直居中 */
  left: 50% !important; /* 水平居中 */
  transform: translate(-50%, -50%) !important; /* 偏移修正 */
  width: auto !important; /* 宽度自适应 */
  min-width: 200px; /* 最小宽度 */
  text-align: center; /* 文字居中 */
}
</style>
